<template>
    <div class="container offset">
        
        <form action="">
            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Nome:</label>
                        <input 
                            v-model="membrosInfo.nome" 
                            type="name"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>
        </form>
        
    </div>
</template>

<script>
//import Button from '../../components/Button'
//import Swal from "sweetalert2";
export default {
    name: "MembroCampoInfo",
    components: {
        //Button
    },
    data() {
        return {
            membrosInfo : '',
        };
    },
    props: {
        data: Object,
    },
    
    computed: {
    },
    
    watch: {
        data() {
            this.membrosInfo = this.$props.data;
        },
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
    },
    created(){ 
    }
};
</script>

<style scoped>

    .container{
        width: 100%;
        background-color: white;
    }

    .form-group{
        display: flex;
    }

    .title-style{
        font-size: 1.5rem;
        font-weight: 600;
        color: #656565;        
    }

    .question-style{
        width: 100%;
        font-size: 1rem;
        font-weight: 500;
        color: #656565;
    }

    .image-style{
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
        padding: 1rem;
    }

    .button-div{
        margin-top: 2rem;
    }

    .input-personal {
        padding: 0.2rem 0.4rem;
        font-size: 0.938rem;
        font-weight: 400;
        border-radius: 8px;
        background: #FCFCFC;
        outline: none;
        border: 1px solid rgba(0, 0, 0, 0.11);
        font-weight: lighter;
        padding: 0.2rem 0.4rem;
        box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
    }

    .disabled-style{
        background-color: #D0D0D0 !important;
        cursor: default;
        pointer-events: none;
    }
</style>